/* eslint-disable @typescript-eslint/no-useless-constructor */
import { Injectable } from '@angular/core';
import { BaseStore } from '../shared/service/store/base-store';
import { AppState } from './app.state.model';

@Injectable({
  providedIn: 'root'
})
export class AppStoreService extends BaseStore<AppState> {

  constructor() {
    super();
  }
}
